import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { useSetting } from "../../../hooks/useSetting";
import "../../../i18n";
import i18n from "i18next";
import { useTranslation } from "react-i18next";

function Preferences() {
  const [defaultLanguage, setDefaultLanguage] = useState(
    localStorage.getItem("language") || "en"
  );
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const [fullName, setFullName] = useState(
    localStorage.getItem("fullName") || ""
  );
  const [gender, setGender] = useState(localStorage.getItem("gender") || "");

  const { settingPost, isLoading } = useSetting();
  const { t } = useTranslation();

  useEffect(() => {
    if (defaultLanguage) {
      return;
    } else {
      const browserLanguage = navigator.language || navigator.languages[0];
      const supportedLanguages = ["en", "fr", "el"];
      const defaultLanguageMin = supportedLanguages.includes(
        browserLanguage.split("-")[0]
      )
        ? browserLanguage.split("-")[0]
        : "en";
      setDefaultLanguage(defaultLanguageMin);
    }
  }, [defaultLanguage]);

  useEffect(() => {
    document.body.setAttribute("data-theme", theme);
  }, [theme]);

  // Language change handler
  const changeLanguageHandler = (e) => {
    const selectedLanguage = e.target.value;
    setDefaultLanguage(selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
    localStorage.setItem("setLangu", selectedLanguage);
  };

  // Theme change handler
  const changeThemeHandler = (e) => {
    const selectedTheme = e.target.value;
    setTheme(selectedTheme);
    document.body.setAttribute("data-theme", selectedTheme);
    localStorage.setItem("theme", selectedTheme);
  };

  // Preferences update handler
  const updateHandler = async (event) => {
    event.preventDefault();
    const settingPostResponse = await settingPost(
      fullName,
      gender,
      theme,
      defaultLanguage
    );

    if (settingPostResponse === "success") {
      alert("Profile updated successfully!");
    } else {
      alert("Failed to update profile. Please try again.");
    }
  };

  return (
    <div className="settingsDecription">
      <p>{t("settingPageDes")}.</p>

      <Form onSubmit={updateHandler}>
        <div className="mb-3 col-4">
          <label htmlFor="theme" className="form-label">
            {t("changeTheme")}
          </label>
          <select
            name="theme"
            id="theme"
            className="form-control"
            value={theme}
            onChange={changeThemeHandler}
          >
            <option value="light"> {t("light")}</option>
            <option value="dark">{t("dark")}</option>
          </select>
        </div>

        <div className="mb-3 col-4">
          <label htmlFor="language" className="form-label">
            {t("changeLanguage")}
          </label>
          <select
            className="form-select"
            aria-label="Default select example"
            value={defaultLanguage}
            onChange={changeLanguageHandler}
          >
            <option value="en">{t("english")}</option>
            <option value="fr"> {t("french")}</option>
            <option value="el"> {t("greek")} </option>
          </select>
        </div>

        <Button
          className="reset-consent-button btn btn-success px-3 py-1 fw-bold"
          type="submit"
        >
          {t("update")}
        </Button>
      </Form>
    </div>
  );
}

export default Preferences;
